import { render } from "./App.vue?vue&type=template&id=186477e2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=186477e2&lang=scss"

import exportComponent from "C:\\Users\\giragwe\\Documents\\Github\\2022-PO-JER-GoogleMars\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__